var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-w sidebar selected-menu-color-light menu-has-selected-link",class:[_vm.checkMenuColor,_vm.checkSubMenuColor,_vm.checkAnnimateMenu,_vm.checkLayoutMenu,_vm.checkPositionMenu,_vm.checkfullScreen,_vm.checkMenuImage]})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c83f534","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/user/partials/navbar/web/index.vue
// module id = null
// module chunks = 